<section class="row">
	<ng-content></ng-content>
	<section class="col-21">
		<div class="chart-wrapper">
			<div class="chart-title-section">
				<h3 class="text-16-bold text-uppercase">{{ sectionTitle }}</h3>
			</div>
			<div class="inner-chart-wrapper">
				<div class="left-content-wrapper">
					<div class="chart-legend">
						<div class="legend-item" *ngFor="let category of categories">
							<div class="square" [ngStyle]="{ 'background-color': category.attribute.colorTheme }"></div>
							<span class="text-14 color-secondary">{{ category.formattedValue }}</span>
						</div>
					</div>
				</div>
				<div class="chart-container">
					<bfa-chart [type]="chartType.DoughnutChart" name="areas-to-explore" [data]="data" [data-index]="selectedPortfolioIndex"></bfa-chart>
				</div>
			</div>
		</div>
		<div class="row" *ngIf="chartLink">
			<a class="col-24 cta-link-icon text-16-bold" href="#" [routerLink]="[chartLinkUrl]" [queryParams]="queryParams" [fragment]="chartLink">
				<icon type="chevron-right"></icon> <span>{{ chartLinkText }}</span>
			</a>
		</div>
	</section>
</section>
